import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import ModalPopup from 'components/organisms/modal';
import Button from 'components/atoms/button';
import { showResult } from 'utils';
import { RESET_PASSWORD } from 'services/dataService/resources';
import dataService from 'services/dataService';

const ResetPasswordModal = ({ isOpen, toggle, email }) => {
  const [loading, setLoading] = useState(false);
  const handleSubmit = async () => {
    setLoading(true);
    const { data, error } = await dataService.createList(RESET_PASSWORD, {
      email,
    });
    if (error) return showResult(error);
    if (data) {
      setLoading(false);
      toggle();
      toast.success("'Reset password' link sent to email");
    }
  };
  return (
    <ModalPopup
      isOpen={isOpen}
      toggle={toggle}
      title=""
      className="popup resend-password-popup"
    >
      <div className="resend-password-body">
        <div className="resend-password-title">Send Reset Password Email?</div>
        <div className="resend-password-actions">
          <Button
            onClick={() => handleSubmit()}
            text="Send"
            disabled={loading}
            smallForPhone
          />
          <Button onClick={() => toggle()} text="Cancel" smallForPhone />
        </div>
      </div>
    </ModalPopup>
  );
};
ResetPasswordModal.defaultProps = {
  isOpen: false,
};

ResetPasswordModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  email: PropTypes.string,
  isOpen: PropTypes.bool,
};

export default ResetPasswordModal;
